import {store} from "../../../store";
import {useDispatch as useBaseDispatch} from "react-redux";

const useDispatch = () => useBaseDispatch<typeof store.dispatch>();

export default useDispatch;
